export const create_src_next = u => {
    let paramob = new URLSearchParams
    u = u.replace(/^http:/i,'https:')
    paramob.set('url', u)
    return  `https://www.infoflot.com/_next/image?${paramob.toString()}&w=1304&q=75`
}

const getSrc = ({src, path, filename}) => src ? src : (path ? path : filename)
const getTitle = ({title, description}) => title ? title : description

export const make_headPhotos = ( photos, main=null, dop = {}  ) => {
    let all = photos || []
    let first = all[0]
    let srcAttr

    if (first) {
        let first_src = getSrc(first)
        if (!first_src) console.log('first', first)
        if (first_src.match(/old\.infoflot/) 
            && !first_src.match(/\/Uploads\/[0-9a-f]\/[0-9a-f]\/[0-9a-f]\/[0-9a-f]+\./)  
        ) {// вырожденный случай. нам подсунули несуществующую фотку. Считаем что и остальные тогда такие же
            all = main ? [main] : []
        }
    }

    let headPhotos = all.map( rec => {
        let {id} = rec
        let src = getSrc(rec)
        let src_next = src.match(/(old|booking)\.infoflot/) ? create_src_next(src) : src
        let ret = {
            src_next, id, 
        }
        if (dop.useTitle) {
            let a = getTitle(rec)
            if (a) {
                ret.title = a
            }
        }
        return ret
    } )

    if (dop.makeUniq) {
        headPhotos = makeUniq( headPhotos )
    }
    
    return headPhotos
}

const makeUniq = arr => {
    const map = new Map()
    for (const obj of arr) {
        map.set(obj.src_next, obj)
    } 
    const ret = [...map.values()]
    return ret
}
